import { z } from "zod";

export const answerRepliesSettingSchema = z.object({ enabled: z.boolean() }).strict();
export type AnswerRepliesSetting = z.infer<typeof answerRepliesSettingSchema>;
